import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/dark-theme.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  if (isHomePage) {
    // No sidebar for homepage - full width
    return (
      <div className="min-h-screen bg-dark-background">
        {children}
      </div>
    );
  }

  // Layout for other pages
  return (
    <div className="min-h-screen bg-dark-background">
      {/* Main content */}
      <main className="p-4 md:p-6">
        {children}
      </main>
    </div>
  );
};

export default Layout; 